import { useBeginGoogleAdsOAuth } from '@/queries/connections/useBeginGoogleAdsOAuth'
import { useConnections } from '@/queries/connections/useConnections'
import { useConsumerToken } from '@/queries/kolla/useConsumerToken'
import { useStytchOrganization } from '@stytch/react/b2b'
import { Connection } from 'honeygrid-types/validators-and-types/ConnectionTypes'
import { useState } from 'react'
import { FaTooth } from 'react-icons/fa'
import { SiGoogleads } from 'react-icons/si'
import { toast } from 'sonner'

import { ConnectionCard } from '../Card/ConnectionCard'
import { CreateConnectionDialog } from '../CreateConnectionDialog'
import { EmptyList } from '../EmptyList'
import { SidePanel } from '../SidePanel'

export const ConnectionsLeftNav = () => {
	const [createDialogOpen, setCreateDialogOpen] = useState(false)
	const { organization } = useStytchOrganization()
	const { data: connections, isLoading } = useConnections(organization?.organization_id)
	const { mutate: beginGoogleAdsOAuth } = useBeginGoogleAdsOAuth()
	const getConsumerTokenMutation = useConsumerToken()
	const showEmptyList = !isLoading && !connections?.length

	/**
	 * Handle Kolla Connect auth flow for Dental PMS integrations
	 */
	const handleKollaConnect = async () => {
		try {
			console.log('Starting Kolla Connect auth flow...')

			// Step 1: Get consumer token from our backend
			const result = await getConsumerTokenMutation.mutateAsync({
				workspaceId: organization?.organization_id,
				workspaceName: organization?.organization_name,
			})

			console.log('Consumer token received:', result.token)

			// Step 2: Authenticate with Kolla SDK
			console.log('Authenticating with Kolla SDK...')
			const authResult = await (window as any).kolla.authenticate(result.token)
			console.log('Kolla auth result:', authResult)

			// Step 3: Open the marketplace modal
			console.log('Opening Kolla marketplace...')
			const marketplaceResult = await (window as any).kolla.openMarketplace()
			console.log('Kolla marketplace result:', marketplaceResult)
		} catch (error) {
			console.error('Failed to start Kolla Connect auth flow:', error)
			alert('Failed to start integration flow. Please try again.')
		}
	}

	return (
		<>
			<SidePanel
				header={{
					title: 'Connections',
					onAdd: () => {
						setCreateDialogOpen(true)
					},
				}}
			>
				<div className="flex flex-col gap-2">
					{showEmptyList ? (
						<EmptyList
							componentPluralName="connections"
							componentSingularName="connection"
							onAdd={() => {
								setCreateDialogOpen(true)
							}}
						/>
					) : (
						connections?.map((connection: Connection) => (
							<ConnectionCard key={connection.uuid} connection={connection} />
						))
					)}
				</div>
			</SidePanel>
			<CreateConnectionDialog
				open={createDialogOpen}
				onOpenChange={setCreateDialogOpen}
				items={[
					{
						icon: <SiGoogleads />,
						name: 'Google Ads',
						onClick: () => {
							if (!organization?.organization_id) {
								toast.error('Organization not found')
								return
							}
							beginGoogleAdsOAuth(organization.organization_id)
						},
					},
					{
						icon: <FaTooth />,
						name: 'Dental PMS',
						onClick: handleKollaConnect,
					},
				]}
			/>
		</>
	)
}
